/**
 * Constants for PT Activation feature
 */

/**
 * Dialog messages for PT activation warning
 */
export const PT_ACTIVATION_MESSAGES = {
    DIALOG_TITLE: 'Activate Inactive Product Type?',
    DIALOG_MESSAGE: (ptName: string) =>
        `This content is linked to Product Type '${ptName}' which is currently inactive. Activating this Product Type will also activate all linked content.`,
    CANCEL_BUTTON: 'Cancel',
    PROCEED_BUTTON: 'Proceed',
    PROCESSING_BUTTON: 'Processing...',
} as const

/**
 * Error messages for PT activation failures
 */
export const PT_ACTIVATION_ERRORS = {
    ACTIVATION_FAILED: 'Failed to add Product Type to project. Please try again.',
    PT_NODE_MISSING: 'Product Type information is missing.',
    NETWORK_ERROR: 'Network error occurred. Please check your connection.',
    ELEMENT_NODES_NOT_AVAILABLE: 'Element nodes not available for the current family.',
    CONTRIBUTOR_NOT_ALLOWED_TITLE: 'Unable to Activate/Inactivate Product Type',
    CONTRIBUTOR_NOT_ALLOWED_MESSAGE: 'Product type activation is restricted to Admins and Authors. As a Contributor, you can only interact with product types that have already been added to the project.',
} as const

/**
 * Pluralization helpers for Product Type labels and messages
 */
export const PT_LABELS = {
    /**
     * Returns "Product Type" or "Product Types" based on count
     */
    PRODUCT_TYPE: (count: number) => (count === 1 ? 'Product Type' : 'Product Types'),

    /**
     * Returns formatted count with pluralized label (e.g., "1 Product Type", "3 Product Types")
     */
    COUNT_WITH_LABEL: (count: number) => `${count} Product ${count === 1 ? 'Type' : 'Types'}`,
} as const

/**
 * Success messages for PT operations
 */
export const PT_SUCCESS_MESSAGES = {
    ACTIVATED: (count: number) => `${PT_LABELS.PRODUCT_TYPE(count)} activated successfully`,
} as const

/**
 * Error messages for PT operations with pluralization
 */
export const PT_ERROR_MESSAGES = {
    ACTIVATION_FAILED: (count: number) => `Failed to activate ${PT_LABELS.PRODUCT_TYPE(count)}`,

    ADD_TO_PROJECT_FAILED: (count: number) =>
        `Failed to Add ${PT_LABELS.PRODUCT_TYPE(count)} to Project`,

    UNEXPECTED_ERROR: (count: number) =>
        `An unexpected error occurred while adding ${PT_LABELS.PRODUCT_TYPE(count)}.`,
} as const

/**
 * Dialog content messages with pluralization
 */
export const PT_DIALOG_CONTENT = {
    REQUIRES_PT_ADDITION: (count: number) =>
        `This action requires the following ${PT_LABELS.PRODUCT_TYPE(count)} to be added:`,
} as const